var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import en from '../i18n/en.json';
import sprintf from 'sprintf-js';
var translations = { en: en };
var fallback = 'en';
var language = fallback;
export var setLanguage = function (selectedLanguage) { return language = selectedLanguage; };
var translation = function (key) {
    return translations[language][key] || translations[fallback][key] || key;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var translate = function (key) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return args.length > 0
        ? sprintf.sprintf.apply(sprintf, __spreadArray([translation(key)], args, false)) : translation(key);
};
export default translate;
